<template>
    <div>
        <div v-for="(item, index) in items" :class="getAnimated(item.id)" v-show="displayByMode(item)" >
            <div style="float:right;margin: 10px;">
                    <s-button 
                        label="en savoir plus" 
                        theme="is-light is-small"
                        icon="info"
                        @onclick="enSavoirPlus(item.id)" />
            </div>
            <div v-on:click="selectItem(item.id)" >
                 
                <div class="imgmode">
                    <img-change :classes="item.classPlayer1" :change="item.change" :animation="animation"/>
                    
                </div>
                <div class="imgmode" 
                     v-show="getNb(index)>1">
                    <img-change :classes="item.classPlayer2" :change="item.change"  :animation="animation"/>
                </div>
                <div class="imgmode" v-show="getNb(index)>2">
                    <img-change :classes="item.classPlayer3" :change="item.change"  :animation="animation"/>
                </div>
                <div class="labelmode" >
                    <div class="titlemode">
                        {{item.title}} <s-arrow :id="item.title"/>
                    </div>
                    
                </div>
               
            </div>
             <div :class="SetEnSavoirPlus==item.id ? 'smodal animateOpen' : 'smodal close'">
                    <div style="float:right;">
                        <s-button theme="is-normal" label="" icon="times-circle" @onclick="SetEnSavoirPlus=null"/>
                    </div>
                    <b> {{item.title}}</b>
                    <div style="padding-top: 20px">
                    <s-l :id="'listSelect_'+item.title">{{item.description}}</s-l>
                    </div>
             </div>
        </div>
    </div>
</template>
<style scoped>
    .smodal {
        font-size: 20px;
        position: absolute;
        top: 20%;
        left: 5%;
        border-radius: 20px;
        border: thin silver solid ;
        padding : 15px;
        background-color: rgb(250, 250, 249);
        color: black;
        text-overflow: clip;
        width: 350px;
        height: 350px;
        visibility: hidden;
        display: table-cell;
        vertical-align: middle;
        text-align: justify;
        box-shadow: 10px 5px 5px gray;
    }
    @keyframes openPlus {
        0% {
            transform: scale(0) rotate(360deg);
        }
        60% {
            transform: scale(0.8) rotate(-10deg);
        }
        100% {
            transform: scale(1) rotate(0deg);
        }
    }
    
    .animateOpen {
        -webkit-animation: openPlus 1s ease forwards; /*trigger the keyframe*/
        visibility: visible;
        z-index: 200;
        opacity: 1;
    }

    .displayNone {
       
    }
     .animateClose {
       animation-name: reducePlus;
       animation-duration: 5s; 
       animation-fill-mode: forwards;
    }
    .boxItem {
        height: 120px;
        width: 100%;
        border: thin solid silver;
        margin-top: 20px;
        padding: 0px;
        color: black;
        
    }
    .boxItem:hover{
        background-color: rgb(236, 236, 209);
        cursor: pointer;
       
    }
     .imgmode {
        float: left;
        width: 60px;
        height: 100px;
        padding-left: 0px;
        padding-bottom: 10px;
    }
     .labelmode {
       text-align: right;
       width: 100%;
       padding-top: 60px;
       padding-right: 10px;
       font-size: 18px;
       font-weight: bolder;
    }
    .description {
        margin-top: 100px;
        font-size: 20px;
    }
    .titlemode {
        position: relative;
    }
</style>
<script>
import imgChange from "@/components/imgChange.vue"
export default {
    props: ["nb","items", "animation", "nbs", "mode"],
    components: {
        imgChange
    },
    data() {
        return {
            SetEnSavoirPlus: null,
            timeOut: [],
            classImage1: ['','',''],
            classImage2: ['','',''],
            classImage3: ['','','']
        }
    },
    methods: {
        displayByMode(item) {
            if (typeof(item.mode)!="undefined") {
                return (item.mode == this.mode)
            }
            else
                return true;
        },
        getNb(index) {
            if (typeof(this.nb)!="undefined")
                return this.nb;
            else if  (typeof(this.nbs)!="undefined")
                return this.nbs[index];
            else 
                return 0;
        },
        selectItem(id) {
            this.$tuto(this.items[id].title, false, this.$route.name, "", (okGo)=>{
					if (okGo) {
			            this.$emit("select", this.items[id].value);
					}
				});
        },
        enSavoirPlus(id) {
            if (this.SetEnSavoirPlus==null)
                this.SetEnSavoirPlus = id;
            else if (this.SetEnSavoirPlus==id)
                this.SetEnSavoirPlus = null;
            else
                this.SetEnSavoirPlus = id;
        },
        getAnimated(id) {
            if (this.SetEnSavoirPlus!=null) {
                if (this.SetEnSavoirPlus==id)
                    return 'boxItem ';
                else
                    return 'boxItem displayNone';
            }
            else {
                return 'boxItem';
            }
        },
       
    },
   
    
}
</script>